export class AsyncDownloadCheckListItemDataObject {
	/**
	 * @param {string} requestId - The unique identifier for the async download request.
	 * @param {AsyncDownloadType} type - The type associated with the async download request.
	 * @param {AsyncDownloadCheckListItemStatus} status - The current status of the checklist item.
	 * @param {string} fileName - The name of the file associated with the async download request.
	 */
	constructor(requestId, type, status, fileName) {
		this.requestId = requestId;
		this.type = type;
		this.status = status;
		this.fileName = fileName;
	}
}